import { defineStore } from 'pinia';

export const useShoppingCartStore = defineStore('shoppingCart', {
  state: () => ({
    cart:  [],
    cartItemCount: 0,
  }),
persist: true,
  getters: {
    totalCartAmount: (state) =>
      state.cart.reduce((sum, item) => sum + item.quantity * item['Variant Price'], 0),
    totalItemCount: (state) =>
      state.cart.reduce((sum, item) => sum + item.quantity, 0),
  },

  actions: {
    addToCart(payload) {
      const existing = this.cart.find(
        (item) =>
          item['Product Id'] === payload['Product Id'] &&
          item['Variant Id'] === payload['Variant Id']
      );
      if (existing) {
        existing.quantity += payload.quantity;
      } else {
        this.cart.push({ ...payload, quantity: payload.quantity || 1 });
      }
      this.saveCart();
    },

    removeFromCart(payload) {
      const index = this.cart.findIndex(
        (item) =>
          item['Product Id'] === payload['Product Id'] &&
          item['Variant Id'] === payload['Variant Id']
      );
      if (index !== -1) {
        if (this.cart[index].quantity > 1) {
          this.cart[index].quantity -= 1;
        } else {
          this.cart.splice(index, 1);
        }
      }
      this.saveCart();
    },

    deleteItemFromCart(payload) {
      this.cart = this.cart.filter(
        (item) =>
          !(
            item['Product Id'] === payload['Product Id'] &&
            item['Variant Id'] === payload['Variant Id']
          )
      );
      this.saveCart();
    },

    deleteCart() {
      this.cart = [];
      window.localStorage.removeItem('cart');
    },

    saveCart() {
      window.localStorage.setItem('cart', JSON.stringify(this.cart));
    },
  },
});
